__turbopack_context__.v({
  "publisherSection": "gGLR1q_publisherSection",
});
